import { render, staticRenderFns } from "./history-modal.vue?vue&type=template&id=0b294c49"
import script from "./history-modal.vue?vue&type=script&lang=js"
export * from "./history-modal.vue?vue&type=script&lang=js"
import style0 from "./history-modal.vue?vue&type=style&index=0&id=0b294c49&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports